import React from "react";

function VORSign() {
  return (
    <>
      {/* CSS for print functionality to make the sign bold, red, and full-page landscape */}
      <style>
        {`
          /* Base styling for the sign */
          .vor-sign-text {
            font-size: 20vw; /* Use viewport units to scale with the page */
            line-height: 0.8; /* Reduce line height to minimize vertical space */
          }
          
          @media print {
            /* Hide everything on the page except the VORSign container */
            body * {
              visibility: hidden;
            }
            #VORSign, #VORSign * {
              visibility: visible;
              color: red !important; /* Force text to be red */
              font-weight: bold !important; /* Force text to be bold */
            }
            #VORSign {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4 landscape; /* Use landscape orientation for the sign */
              margin: -55mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide the print button when printing */
            .print-button {
              display: none;
            }
            /* Adjust font size to fill the page more effectively in print */
            .vor-sign-text {
                font-size: 20vw !important;
                letter-spacing: 5vw !important; /* Increase spacing to fill width */
            }
          }
        `}
      </style>

        {/* Print Button */}
        <div className="mt-6 text-right print-button">
          <button
            type="button"
            onClick={() => window.print()}
            className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg"
          >
            Print Form
          </button>
      </div>

      <div id="VORSign" className="flex justify-center items-center p-4 border rounded-lg bg-white shadow-md w-full h-screen">
        <div className="flex justify-center items-center flex-col w-full h-full border-black">
          <p className="vor-sign-text text-red-500 text-center uppercase leading-none">
            VOR
          </p>
        </div>
      </div>
    </>
  );
}

export default VORSign;